// src/components/finance/steps/FinancialStep.jsx
import React, { useState } from 'react';
import '../../../styles/LoanSteps.css';

const FinancialStep = ({ data, car, onNext, onPrevious, loading }) => {
  const carPrice = car?.price || 0;

  const [formData, setFormData] = useState({
    down_payment: data.down_payment || 0,
    loan_amount_requested: data.loan_amount_requested || carPrice,
    tenure_requested: data.tenure_requested || 60
  });

  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    let updatedData = { ...formData, [field]: value };
    
    // Auto-calculate loan amount when down payment changes
    if (field === 'down_payment') {
      updatedData.loan_amount_requested = carPrice - parseFloat(value || 0);
    }
    
    setFormData(updatedData);
    setErrors({ ...errors, [field]: '' });
  };

  const validate = () => {
    const newErrors = {};
    
   

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      onNext(formData);
    }
  };

  return (
    <div className="step-container">
      <div className="step-header">
        <h3>Monthly take-home salary</h3>
        <p>Exclusive of incentives, bonus etc.</p>
      </div>

      <form onSubmit={handleSubmit} className="step-form">
       

        <div className="loan-summary-card">
          <h4>Loan Details</h4>
          <div className="summary-row">
            <span>Car Price:</span>
            <strong>₹{carPrice.toLocaleString('en-IN')}</strong>
          </div>
          <div className="summary-row">
            <span>Down Payment:</span>
            <input
              type="number"
              value={formData.down_payment}
              onChange={(e) => handleChange('down_payment', e.target.value)}
              placeholder="0"
              min="0"
              max={carPrice}
              className="inline-input"
            />
          </div>
          <div className="summary-row highlight">
            <span>Loan Amount:</span>
            <strong>₹{parseFloat(formData.loan_amount_requested).toLocaleString('en-IN')}</strong>
          </div>
          <div className="summary-row">
            <span>Tenure:</span>
            <select
              value={formData.tenure_requested}
              onChange={(e) => handleChange('tenure_requested', e.target.value)}
              className="inline-select"
            >
              <option value="12">12 Months</option>
              <option value="24">24 Months</option>
              <option value="36">36 Months</option>
              <option value="48">48 Months</option>
              <option value="60">60 Months</option>
              <option value="84">84 Months</option>
            </select>
          </div>
        </div>

        <div className="info-banner">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="#3B82F6">
            <circle cx="10" cy="10" r="9" fill="none" stroke="currentColor" strokeWidth="2"/>
            <path d="M10 6v4M10 14h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          <p>Processing fee and other charges are not included in this estimate</p>
        </div>

        <div className="button-group">
          <button type="button" onClick={onPrevious} className="previous-button">
            Previous
          </button>
          <button type="submit" className="next-button" disabled={loading}>
            {loading ? 'Processing...' : 'Next'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default FinancialStep;